import { render } from "./ComboboxRoot.vue?vue&type=template&id=31c42eeb&ts=true"
import script from "./ComboboxRoot.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComboboxRoot.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/combobox/ComboboxRoot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31c42eeb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31c42eeb', __exports__)) {
    api.reload('31c42eeb', __exports__)
  }
  
  module.hot.accept("./ComboboxRoot.vue?vue&type=template&id=31c42eeb&ts=true", () => {
    api.rerender('31c42eeb', render)
  })

}


export default __exports__